import type { IdentifierModel, UUID } from "@overmap-ai/common"
import { type Field, UNLABELLED_FIELD_LABEL } from "@overmap-ai/forms"

import { CSV_COLUMN_HEADER_DELIMETER } from "./constants"

export function getFieldCsvColumnHeader(field: Field) {
	return `${field.label || UNLABELLED_FIELD_LABEL} ${CSV_COLUMN_HEADER_DELIMETER} ${field.id}` as const
}

export function getIdentifierCsvColumnHeader(identifier: UUID<IdentifierModel>) {
	return `${identifier.name} ${CSV_COLUMN_HEADER_DELIMETER} ${identifier.uuid}` as const
}
